export enum GameTypes {
  OKL = -1,
  GIN = 0,
  MAX = 10,
};

export enum Phases {
	PLAY = 1,
	SHOW = 2
};

export const gameTypes = {
  'oklahoma': GameTypes.OKL,
  'gin_only': GameTypes.GIN,
  'regular_gin': GameTypes.MAX,
}
